import { ButtonProps, Group, Image } from "@mantine/core"
import Link from "next/link"
import { ElementType } from "react"

type HeaderProps = {
  qualifyButton: ElementType<ButtonProps<"a">>
}

export const Header = ({ qualifyButton: QualifyButton }: HeaderProps) => (
  <Group position="apart" align="flex-start">
    <Link href="/" passHref>
      <a>
        <Image src="/img/logo.webp" width={225} height={85} alt="" />
      </a>
    </Link>
    <QualifyButton sx={{ position: "fixed", right: "50px" }} />
  </Group>
)
